import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRegisterSellerMutation } from "../redux/apislice";
import toast from "react-hot-toast";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    storename: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    gender: "",
    dob: "",
    description: "",
    short_des: "",
    title: "",
    image: null,
    terms: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const [registerSeller, { isLoading }] = useRegisterSellerMutation();

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.short_des.length < 10 || formData.short_des.length > 160) {
      toast.error("Short description must be between 10-160 characters.");
      return;
    }

    if (!formData.terms) {
      toast.error("Please accept terms and conditions.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    if (!formData.image) {
      toast.error("Please upload your profile/store picture.");
      return;
    }

    const formPayload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (key !== "terms" && key !== "confirmPassword") {
        formPayload.append(key, value);
      }
    });

    try {
      const response = await registerSeller(formPayload).unwrap();

      if (response.status === false) {
        toast.error(response.message || "Registration failed!");
        return;
      }

      toast.success(
        response.message || "Registration successful! Please login"
      );
      console.log("Response:", response);
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(
        error?.data?.message || "Something went wrong. Please try again!"
      );
    }
  };

  return isLoading ? (
    <div className="absolute top-0 left-0 w-full h-screen bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12"></div>
    </div>
  ) : (
    <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-purple-900 to-black px-4 py-8">
      <div className="w-full max-w-md bg-gray-50 rounded-2xl shadow-lg p-6 sm:p-8">
        <h2 className="text-2xl font-bold mb-4 text-center text-purple-800">
          Create an Account
        </h2>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          <input
            name="name"
            disabled={isLoading}
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            className="input-style"
            required
          />
          <input
            name="storename"
            type="text"
            placeholder="Store name"
            value={formData.storename}
            onChange={handleChange}
            className="input-style"
            required
          />
          <input
            name="title"
            type="text"
            placeholder="Tagline"
            value={formData.title}
            onChange={handleChange}
            className="input-style"
            required
          />
          <input
            type="email"
            name="email"
            disabled={isLoading}
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="input-style"
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            disabled={isLoading}
            value={formData.phone}
            onChange={handleChange}
            className="input-style"
            required
          />
          
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="input-style w-full"
              required
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-purple-700"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              )}
            </button>
          </div>

          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Password"
              disabled={isLoading}
              value={formData.confirmPassword}
              onChange={handleChange}
              className="input-style w-full"
              required
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-purple-700"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              )}
            </button>
          </div>

          <select
            name="gender"
            value={formData.gender}
            disabled={isLoading}
            onChange={handleChange}
            className="input-style"
            required
          >
            <option value="">Select Gender</option>
            <option> MALE</option>
            <option> FEMALE</option>
            <option> NON_BINARY</option>
            <option> TRANSGENDER</option>
            <option> INTERSEX</option>
            <option> PREFER_NOT_TO_SAY</option>
            <option>OTHER</option>
          </select>

          <input
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleChange}
            className="input-style"
            disabled={isLoading}
            required
          />

         

          <div>
            <textarea
              name="short_des"
              placeholder="shortly Describe your store’s niche in few words. (10-160 characters)"
              value={formData.short_des}
              onChange={handleChange}
              className="input-style"
              rows={3}
              maxLength={160}
              required
            />
            <p className="text-xs text-gray-500 mt-1">
              {formData.short_des.length}/160 characters
              {formData.short_des.length < 10 && (
                <span className="text-red-500"> (Minimum 10 characters required)</span>
              )}
            </p>
          </div>
           <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
            className="input-style"
            disabled={isLoading}
            rows={2}
            
          ></textarea>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Upload Store Logo here 
            </label>
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={handleChange}
              className="input-style"
              required
            />
            {formData.image && (
              <div className="mt-2">
                <img
                  src={URL.createObjectURL(formData.image)}
                  alt="Preview"
                  className="h-20 w-20 rounded-full object-cover border-2 border-purple-500"
                />
              </div>
            )}
          </div>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="terms"
              checked={formData.terms}
              disabled={isLoading}
              onChange={handleChange}
              className="h-4 w-4 text-purple-600"
              required
            />
            <span className="text-xs text-gray-600">
              I agree to the Terms and Conditions
            </span>
          </label>

          <button
            type="submit"
            disabled={isLoading}
            className="bg-purple-700 hover:bg-purple-800 text-white font-medium py-2 rounded-lg transition duration-200"
          >
            {isLoading ? "Registering..." : "Register"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="mt-4 text-purple-700 hover:text-purple-900 text-sm underline text-center w-full"
          >
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;